<template>
  <div id="app">
    <div v-if="!started" id="introCard" >
      <h1>Everything A Cycle: {{iteration}}</h1>
      <p v-if="subtitle" v-cloak>{{subtitle}}</p>
      <div id="instructions" v-if="instructions">
        <p v-cloak>{{instructions}}</p>
      </div>
      <button @click="start">Start</button>
    </div>
    <div v-else id="canvas">

    </div>
    <a href="https://awakening.systems" target="_blank">
      <img id="logo" src="@/assets/icon.png" />
    </a>
  </div>
</template>

<script>
var _ = require('lodash')
var p5 = require('p5')
let machineSynth, humanSynth, composition

let baseCircle
let baseTriUp
let baseTriDown

let innerCircleTop
let innerCircleTopTriDown

let centerDiamond

let innerCircleMid
let innerCircleMidTriUp
let innerCircleMidTriDown

let innerCircleBot
let innerCircleBotTriUp

let circles

export default {
  data() {
    return {
      started: false,
      iteration: '02',
      subtitle: 'a universe in seven',
      instructions: 'Use the 1 > 7 keys to play'
    }
  },
  methods: {
    async start() {
      this.started = true

      await Tone.start()
      await Tone.Transport.start()
      Tone.Transport.bpm.value = 45

      setTimeout(_ => {
        machineSynth = require('@/audio/synth-machine.js').patch
        humanSynth = require('@/audio/synth-human.js').patch
        composition = require('@/audio/composition-config.js').composition
        this.startAudio()
        const noise = new Tone.Noise("pink").start();
        const autofilter = new Tone.AutoFilter("4n")
        const volume = new Tone.Volume(-30)
  
        noise.chain(autofilter, volume, Tone.Destination)
      }, 1500)
      this.visualStart()
      this.initKeys()
    },
    startAudio() {

      let lastNote = _.last(composition.events);
      let endOfLoop = Tone.Time(lastNote.time) + Tone.Time(lastNote.duration)
      let rest = Tone.Time(composition.rest).toSeconds();
      let interval = endOfLoop + rest;

      let part = new Tone.Part((time, event) => {
        machineSynth.synth.triggerAttackRelease(
          event.note,
          event.duration,
          time,
          event.velocity
        );


        Tone.Draw.schedule(() => {
          if(event.change) {
            circles[event.circleOff].deactivate()
            circles[event.circleOn].activate()
          }
        }, time);

      }, composition.events);
      part.loopEnd = interval;
      part.loop = true;
      part.start();
    },
    visualStart() {
      var ctx
      let circleCenter = {x: 0, y: 0}
      let circleDiameter = 600
      let lightStroke = [33, 8, 24]
      let darkStroke = [0, 0, 0]
      let activeFill = [204, 133, 209, 255]
      let rotationSpeed = 0.15
      let possibleNotes = ['G2', 'A2', 'B2', 'C3', 'D3', 'E3', 'F#3']
      const s = (sketch) => {

        sketch.setup = function() {
          sketch.createCanvas(sketch.windowWidth, sketch.windowHeight)   
         6
         sketch.angleMode(sketch.DEGREES)
          sketch.textFont('Big Caslon', 12)
          sketch.textAlign(sketch.CENTER)
          ctx = sketch.drawingContext

          baseCircle = new CircleShape(circleCenter.x, circleCenter.y, circleDiameter, 'WHOLE MIND EMULATION', sketch) 
          baseTriUp = new TriangleShape(circleCenter.x, circleCenter.y, circleDiameter, 'up', 'solid', 'ASTRAL', 'SACRAL', 'PRESENTATION',  sketch)
          baseTriDown = new TriangleShape(circleCenter.x, circleCenter.y, circleDiameter, 'down', 'solid','DIVINE', 'BROW', 'DATALINK', sketch)

          innerCircleTop = new CircleShape(circleCenter.x, circleCenter.y - circleDiameter / 4, circleDiameter / 2, 'INSPIRATION', sketch)
          innerCircleTopTriDown = new TriangleShape(circleCenter.x, circleCenter.y - circleDiameter / 4, circleDiameter / 2, 'down', 'dash', 'LOGOIC', 'PHYSICAL', 'CROWN', sketch)
        
          centerDiamond = new Diamond(circleCenter.x, circleCenter.y, 'SPIRITUAL', 'TRANSPORT', 'HEART', sketch)
          
          innerCircleMid = new CircleShape(circleCenter.x, circleCenter.y, circleDiameter / 2, 'PASSION', sketch)
          innerCircleMidTriDown = new TriangleShape(circleCenter.x, circleCenter.y, circleDiameter / 2, 'down', 'solid', 'BUDDHIC', 'THROAT', 'NETWORK', sketch)
          innerCircleMidTriUp = new TriangleShape(circleCenter.x, circleCenter.y, circleDiameter / 2, 'up', 'solid', 'MENTAL', 'SOLAR PLEXUS',  'SESSION', sketch)
          
          innerCircleBot = new CircleShape(circleCenter.x, circleCenter.y + circleDiameter / 4, circleDiameter / 2, 'DESIRE', sketch)
          innerCircleBotTriUp = new TriangleShape(circleCenter.x, circleCenter.y + circleDiameter / 4, circleDiameter / 2, 'up', 'dash', 'PHYSICAL', 'ROOT', 'APPLICATION', sketch) 

          circles = [innerCircleBot, innerCircleMid, innerCircleTop]
          innerCircleMid.activate()
        }

        sketch.draw = function() {
          sketch.background(83, 23, 60, 25);
          sketch.noFill()
          sketch.translate(sketch.width/2, sketch.height/2)

          baseCircle.renderShape()
          baseCircle.renderText()

          baseTriUp.renderShape()
          baseTriUp.renderText()

          baseTriDown.renderShape()
          baseTriDown.renderText()

          innerCircleTop.renderShape()
          innerCircleTop.renderText()

          innerCircleTopTriDown.renderShape()
          innerCircleTopTriDown.renderText()

          centerDiamond.renderShape()
          centerDiamond.renderText()

          innerCircleMid.renderShape()
          innerCircleMid.renderText()

          innerCircleMidTriUp.renderShape()
          innerCircleMidTriUp.renderText()

          innerCircleMidTriDown.renderShape()
          innerCircleMidTriDown.renderText()

          innerCircleBot.renderShape()
          innerCircleBot.renderText()

          innerCircleBotTriUp.renderShape()
          innerCircleBotTriUp.renderText()
        }

        sketch.windowResized = function() {
          sketch.resizeCanvas(sketch.windowWidth, sketch.windowHeight)
        }
      }

      class AnimationBase {
        constructor() {
          this.active = false
          this.rotation = 0
          this.rotationSpeed = 0.25
        }
        
        activate(key) {
          if(key) {
            let noteToPlay = possibleNotes[key - 1]
            humanSynth.synth.triggerAttack(noteToPlay)
          }
          this.active = true
        }

        deactivate(key) {
          if(key) {
            let noteToPlay = possibleNotes[key - 1]
            humanSynth.synth.triggerRelease(noteToPlay)
          }
          this.active = false
        }
      }

      class CircleShape extends AnimationBase {
        constructor(xPos, yPos, diameter, text, sketch) {
          super()
          this.x = xPos
          this.y = yPos
          this.diameter = diameter
          this.text = text
        }

        renderText() {
          sketch.push()
          sketch.translate(this.x, this.y)
          sketch.textAlign(sketch.CENTER, sketch.CENTER)

          if(this.active) {
            sketch.stroke(darkStroke)
            sketch.fill(activeFill)
            sketch.rotate(this.rotation)
            this.rotation += rotationSpeed
          } else {
            sketch.noStroke()
            sketch.fill(darkStroke)
          }

          let totalAngle = sketch.textWidth(this.text) / (this.diameter / 2)
            
          for (let j = 0; j < 2; j++) {
            let arcLength = 0
            for (let i = 0; i < this.text.length; i++) {
              let currentChar = this.text.charAt(i)
              let w = sketch.textWidth(currentChar)
              arcLength += w / 2
      
              let theta = sketch.degrees(arcLength / (this.diameter / 2) - (totalAngle /2)) + (j * 180) + 90
              sketch.push()
              sketch.translate(0, 0)
              sketch.rotate(theta)
              sketch.translate(0, -this.diameter / 2)
              sketch.text(currentChar, 0, -15)
              sketch.pop()
              arcLength += w / 1.25
            }
          }
          sketch.pop()
        }

        renderShape() {
          sketch.push()
          sketch.translate(this.x, this.y)

          sketch.stroke([33, 8, 24])
          if (this.active == true) {
            sketch.strokeWeight(2)
            sketch.stroke(activeFill)
            sketch.rotate(this.rotation)
            this.rotation += rotationSpeed
          }

          ctx.setLineDash([3, 6])
          sketch.circle(0, 0, this.diameter)
          ctx.setLineDash([4, 5])
          sketch.circle(0 + 0.5, 0 + 0.5, this.diameter + 0.5)

          sketch.pop()
        }
      }

      class TriangleShape extends AnimationBase {
        constructor(xPos, yPos, parentDiameter, initialOrientation, strokeType, text0, text1, text2, sketch) {
          super()
          this.x = xPos
          this.y = yPos
          this.sideLength = parentDiameter / 2
          this.initialOrientation = initialOrientation
          this.strokeType = strokeType
          this.text = text0
          this.text1 = text1
          this.text2 = text2
          this.v1 = {}
          this.v2 = {}
          this.v3 = {}

          if (this.initialOrientation == 'up') {
            this.v1 = {
              x: this.sideLength * sketch.cos(30),
              y: this.sideLength * sketch.sin(30)
            }
            this.v2 = {
              x: this.sideLength * sketch.cos(150),
              y: this.sideLength * sketch.sin(150)
            }
            this.v3 = {
              x: this.sideLength * sketch.cos(270),
              y: this.sideLength * sketch.sin(270)
            }
          }

          if (this.initialOrientation == 'down') {
            this.v1 = {
              x: this.sideLength * sketch.cos(-30),
              y: this.sideLength * sketch.sin(-30)
            }
            this.v2 = {
              x: this.sideLength * sketch.cos(-150),
              y: this.sideLength * sketch.sin(-150)
            }
            this.v3 = {
              x: this.sideLength * sketch.cos(-270),
              y: this.sideLength * sketch.sin(-270)
            }
          }
        }

        renderText() {          
          sketch.push()
          sketch.translate(this.x, this.y)
          sketch.textAlign(sketch.CENTER, sketch.CENTER)
          
          if(this.active) {
            sketch.stroke(activeFill)
            sketch.rotate(this.rotation)
            this.rotation += rotationSpeed
          }

          if(this.active) {
            sketch.stroke(darkStroke)
            sketch.fill(activeFill)
          } else {
            sketch.noStroke()
            sketch.fill(darkStroke)
          }


          if (this.initialOrientation == 'up') {
            sketch.text(this.text, this.x, this.sideLength / 2 - 10)
            if(this.active){
              sketch.rotate(120)
              sketch.text(this.text1, this.x, this.sideLength / 2 - 10)
              sketch.rotate(120)
              sketch.text(this.text2, this.x, this.sideLength / 2 - 10)
            }
          } else if (this.initialOrientation == 'down') {
            sketch.text(this.text, this.x, -this.sideLength / 2 + 10)
            if(this.active) {
              sketch.rotate(120)
              sketch.text(this.text1, this.x, -this.sideLength / 2 + 10)
              sketch.rotate(120)
              sketch.text(this.text2, this.x, -this.sideLength / 2 + 10)
            }
          }
          sketch.pop()
        }

        renderShape() {
          sketch.push()    
          sketch.translate(this.x, this.y)
          sketch.stroke(lightStroke)

          if (this.active == true) {
            sketch.strokeWeight(2)
            sketch.stroke(activeFill)
            sketch.rotate(this.rotation)
            this.rotation += rotationSpeed
          }
          
          if (this.strokeType == 'dash') {
            ctx.setLineDash([3, 6])
          } else {
            ctx.setLineDash([6, 7])
          }
          sketch.triangle(this.v1.x, this.v1.y, this.v2.x, this.v2.y, this.v3.x, this.v3.y)

          ctx.setLineDash([4, 5])
          sketch.triangle(this.v1.x + 0.5, this.v1.y + 0.5, this.v2.x + 0.5, this.v2.y + 0.5, this.v3.x + 0.5, this.v3.y + 0.5)
          sketch.pop()
        }

      }

      class Diamond extends AnimationBase {
        constructor(xPos, yPos, text0, text1, text2) {
          super()
          this.sideLength = 60
          this.x = xPos
          this.y = yPos
          this.text = text0
          this.text1 = text1
          this.text2 = text2
        }

        renderShape() {
          sketch.push()
          sketch.translate(this.x, this.y)

          if(this.active) {
            sketch.rotate(this.rotation)
            this.rotation += rotationSpeed
          }


          sketch.noFill()
          if(this.active) {
            sketch.stroke(activeFill)
          } else {
            sketch.stroke(lightStroke)
          }


          sketch.rectMode(sketch.CENTER)

          sketch.push()
          ctx.setLineDash([4, 6])
          sketch.rotate(90)
          sketch.beginShape()
          sketch.vertex(this.x, this.y + 30)
          sketch.vertex(this.x + 50, this.y)
          sketch.vertex(this.x, this.y - 30)
          sketch.vertex(this.x - 50, this.y)
          sketch.vertex(this.x, this.y + 30)
          sketch.endShape()
          sketch.pop()

          sketch.push()
          ctx.setLineDash([4, 5])
          sketch.rotate(90)
          sketch.beginShape()
          sketch.vertex(this.x, this.y + 30)
          sketch.vertex(this.x + 50, this.y)
          sketch.vertex(this.x, this.y - 30)
          sketch.vertex(this.x - 50, this.y)
          sketch.vertex(this.x, this.y + 30)
          sketch.endShape()
          sketch.pop()

          sketch.pop()
        }

        renderText() {
          sketch.push()
          sketch.translate(this.x, this.y)
          sketch.textAlign(sketch.CENTER, sketch.CENTER)

          if(this.active) {
            sketch.stroke(darkStroke)
            sketch.fill(activeFill)
          } else {
            sketch.noStroke()
            sketch.fill(darkStroke)
          }

          sketch.text(this.text, this.x, this.y)
          if(this.active) {
            sketch.text(this.text1, this.x, this.y + 16)
            sketch.text(this.text2, this.x, this.y - 16)
          }
          sketch.pop()
        }
      }

      let sketch = new p5(s, document.getElementById('canvas'))
    },
    initKeys() {
      document.addEventListener('keydown', (e) => {
        if(!e.repeat) {
          if(e.key == '1') {
            innerCircleBotTriUp.activate(1)
          }
          else if (e.key == '2') {
            baseTriUp.activate(2)
          }
          else if(e.key == '3') {
            innerCircleMidTriUp.activate(3)
          }
          else if(e.key == '4') {
            centerDiamond.activate(4)
          }
          else if(e.key == '5') {
            innerCircleMidTriDown.activate(5)
          }
          else if(e.key == '6') {
            baseTriDown.activate(6)
          }
          else if(e.key == '7') {
            innerCircleTopTriDown.activate(7)
          }
        }
      })

      document.addEventListener('keyup', (e) => {
        if(!e.repeat) {
          if(e.key == '1') {
            innerCircleBotTriUp.deactivate(1)
          }
          else if (e.key == '2') {
            baseTriUp.deactivate(2)
          }
          else if(e.key == '3') {
            innerCircleMidTriUp.deactivate(3)
          }
          else if(e.key == '4') {
            centerDiamond.deactivate(4)
          }
          else if(e.key == '5') {
            innerCircleMidTriDown.deactivate(5)
          }
          else if(e.key == '6') {
            baseTriDown.deactivate(6)
          }
          else if(e.key == '7') {
            innerCircleTopTriDown.deactivate(7)
          }  
        }
      })
    }
  }
}
</script>

<style>
[v-cloak] {
  display: none;
}

#logo {
  opacity: 0.5;
  height: 60px;
  width: 60px;
  position: absolute;
  bottom: 10px;
  right: 10px;
}

#logo:hover {
  opacity: 1
}

html {
  background: #c0b490;
  color: #1A3644;
}

#introCard {
  text-align: center;
}

#instructions {
  margin-top: 48px;
}

button {
  color: #c0b490;
  background: #681916;
  border: #681916;
  cursor: pointer;
  margin-top: 80px;
  height: 40px;
  width: 120px;
  text-transform: uppercase;
  font-size: 12px;
  font-family: 'RobotoSlab';
  font-weight: 200;
}

button:hover {
  background: #7E1916;
}
</style>
